import { formatNumber } from '@/utils/formatters';
import React from 'react';
import {
  CartesianGrid,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Text,
} from 'recharts';
import ChartLoadingOverlay from '../common/ChartLoadingOverlay';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

const LeftYAxisLabel = ({
  viewBox,
  value,
  angle,
  style = {
    fontWeight: 600,
    fontSize: 10,
  },
  offset = 0,
}) => {
  const { x, y, height } = viewBox;
  return (
    <Text
      x={x + offset}
      y={(y * 1) / height + height / 2}
      textAnchor="middle"
      angle={angle}
      style={style}
    >
      {value}
    </Text>
  );
};

function AppBarChart({ data, children, yAxisLabel, xAxisLabel, xAxisDataKey, loading = false }) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <div className="w-full h-full relative">
      {loading && <ChartLoadingOverlay loading={loading} />}

      <ResponsiveContainer
        width="100%"
        height="100%"
        className="border bg-white rounded-md shadow-sm"
      >
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 0" />
          <XAxis
            dataKey={xAxisDataKey}
            label={
              xAxisLabel && {
                value: xAxisLabel,
                position: 'bottom',
                offset: -10,
                style: {
                  fontWeight: 600,
                  fontSize: 10,
                },
              }
            }
            tick={{ fontSize: isMobile ? 9 : 10 }}
          />
          <YAxis
            label={<LeftYAxisLabel value={yAxisLabel} angle={-90} offset={10} />}
            tick={{ fontSize: isMobile ? 9 : 10 }}
            tickFormatter={(value) => formatNumber(value)}
          />
          <Tooltip
            formatter={(value, name, props) => {
              return [
                formatNumber(value),
                name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
              ];
            }}
          />
          <Legend
            layout="horizontal"
            verticalAlign="top"
            align="center"
            wrapperStyle={{ paddingBottom: 8, fontSize: 12 }}
            formatter={(value) => {
              return value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
            }}
          />
          {children}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AppBarChart;
